import { Component, Input } from '@angular/core';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'entity-monitoring-org',
  templateUrl: './entity-monitoring-org.component.html'
})

export class EntityMonitoringOrgComponent {
  @Input() entityIdDetails: EntityIdDetails;
  entityType = 'Org';

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/entitymonitoringorg/entity-monitoring-org.component.ts